import '@diplodoc/transform/dist/css/yfm.css';

import cn from 'classnames';
import { useId, useMemo } from 'react';

import { renderMarkdown } from './renderMarkdown';

import s from './IssueMarkdown.module.scss';

type Props = {
  /** YFM — markdown Яндекс Трекера */
  text: string;
  emptyText: string;
};

const IssueMarkdown: React.FC<Props> = ({ text, emptyText }) => {
  const idPrefix = useId();
  const html = useMemo(() => renderMarkdown({ text, idPrefix }), [text, idPrefix]);

  if (!text.trim()) return <p className={s.empty}>{emptyText}</p>;

  return <div className={cn('yfm', s.markdown)} dangerouslySetInnerHTML={{ __html: html }} />;
};

export { IssueMarkdown };
